import { Reveal } from "./Reveal";
import { Home, DoorOpen, TrendingUp, Ruler } from "lucide-react";

const ITEMS = [
  {
    icon: Home,
    title: "Casa vuota o arredata",
    body: "Lavorare in una casa piena di mobili richiede più tempo e attenzione: spostiamo, proteggiamo, posiamo.",
  },
  {
    icon: DoorOpen,
    title: "Porte da adattare",
    body: "Se ci sono porte, vanno adattate (ribassate) perché scorrano sul nuovo pavimento, senza smontarle.",
  },
  {
    icon: TrendingUp,
    title: "Dislivelli del sottofondo",
    body: "Prima della posa il fondo deve essere piano: i dislivelli si correggono con rasature o massetti.",
  },
  {
    icon: Ruler,
    title: "Battiscopa e finiture",
    body: "Nella posa a correre il battiscopa è già incluso: il dettaglio che chiude il lavoro, senza costi nascosti.",
  },
];

const Conditions = () => (
  <section
    className="bg-paper py-28 md:py-36"
    data-testid="conditions-section"
  >
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="mb-4 font-sans text-xs font-light uppercase tracking-[0.45em] text-clay">
          Trasparenza
        </p>
        <h2 className="max-w-3xl font-display text-4xl font-medium leading-tight text-ink sm:text-5xl">
          Perché il prezzo si conferma{" "}
          <em className="text-honey">dopo il sopralluogo</em>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.1}>
            <div className="group" data-testid={`condition-card-${i}`}>
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-honey/40 text-clay transition-colors duration-300 group-hover:bg-honey group-hover:text-ink">
                <it.icon size={20} strokeWidth={1.6} />
              </div>
              <h3 className="mt-5 font-display text-xl font-medium text-ink">
                {it.title}
              </h3>
              <p className="mt-3 font-sans text-sm font-light leading-relaxed text-bark/80">
                {it.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Conditions;
